import { render, staticRenderFns } from "./FeesForm.vue?vue&type=template&id=560ed88e&scoped=true"
import script from "./FeesForm.vue?vue&type=script&lang=js"
export * from "./FeesForm.vue?vue&type=script&lang=js"
import style0 from "./FeesForm.vue?vue&type=style&index=0&id=560ed88e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ed88e",
  null
  
)

export default component.exports